import { AppButton } from 'components/atoms/CommonAppComponents/AppButton/AppButton';
import styled from 'styled-components';

export const AppModalButton = styled(AppButton)`
    height: 42px;
    margin: 0;
`;
